module.exports = __webpack_public_path__ + "img/success-notice.2c57cf3d.png";